import { Entity } from '../constants';

// TODO: migrate WorkOrder references to GrowerProduct

export type EntityMapperType = { prefix: string; id: string; statuses: string[]; name: string };

export const Mapper: {
  [key in Entity.Type]: EntityMapperType;
} = {
  SalesOrder: {
    prefix: 'SO',
    id: 'salesOrderId',
    statuses: ['DRAFT', 'SUBMITTED', 'PICKING', 'SHIPPED', 'CLOSED', 'CANCELLED', 'ERROR'],
    name: 'Sales Order',
  },
  PurchaseOrder: {
    prefix: 'PO',
    id: 'purchaseOrderId',
    statuses: ['DRAFT', 'SUBMITTED', 'RECEIVING', 'PENDING_LIQUIDATION', 'CLOSED', 'CANCELLED', 'ERROR'],
    name: 'Purchase Order',
  },
  WorkOrder: {
    prefix: 'GP',
    id: 'workOrderId',
    statuses: ['DRAFT', 'SUBMITTED', 'RECEIVING', 'PENDING_SETTLEMENT', 'CLOSED'],
    name: 'Grower Product',
  },
  BuySellOrder: {
    prefix: 'BSO',
    id: 'buySellOrderId',
    statuses: ['DRAFT', 'SUBMITTED', 'PAYMENT_RECONCILIATION', 'CLOSED'],
    name: 'Buy-Sell Order',
  },
  ProductionRun: {
    prefix: 'PR',
    id: 'productionRunId',
    statuses: ['DRAFT', 'SUBMITTED', 'CLOSED'],
    name: 'Production Run',
  },
  Lot: { prefix: '', id: 'lotId', statuses: ['OPEN', 'LOCKED', 'CLOSED'], name: 'Lot' },
  Payment: { prefix: 'PAY', id: 'paymentId', statuses: [], name: 'Payment' },
  Bill: { prefix: 'BILL', id: 'billId', statuses: [], name: 'Bill' },
};
